export default "__VITE_ASSET__D04l2Jrn__"